// extracted by mini-css-extract-plugin
module.exports = {"skeletonCard":"ItineraryCardSkeleton_skeletonCard__y7R6a","body":"ItineraryCardSkeleton_body__Kns_c","skeletonRow":"ItineraryCardSkeleton_skeletonRow__eXppK"};